import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { EProductLibraryStatus } from '../getProductLibrarySyncStatus/getProductLibrarySyncStatus';

export interface IVenueInsert {
  external_id: string;
  name: string;
  code: string;
  address_summary?: string;
}

export interface IVenueChange {
  field: string;
  old_value: string | null;
  new_value: string | null;
}

export interface IVenueUpdate extends IVenueInsert {
  venue_id: string;
  changes: IVenueChange[];
}

export interface IVenueDelete {
  venue_id: string;
  external_id: string;
  name: string;
}

export interface IVenueSyncDiff {
  inserts: IVenueInsert[];
  updates: IVenueUpdate[];
  deletes: IVenueDelete[];
}

export interface IVenueSyncStatus {
  event_id: string;
  status: EProductLibraryStatus;
  external_system_id?: string;
  external_system_name?: string;
  message?: string;
  diff?: IVenueSyncDiff | null;
}

export const getVenuesSyncStatus = async (eventId: string): Promise<IVenueSyncStatus | null> => {
  try {
    const res = await fetch(`${API_URL}/venues/import/status?event_id=${eventId}`);

    if (!res.ok) throw new Error('Response not OK when fetching venue sync status');
    if (res.status === Status.SUCCESS) {
      return await res.json();
    }
    return null;
  } catch (e) {
    const message = e instanceof Error ? e.message : 'Could not get sync status';
    throw new Error(`Could not get sync status: ${message}`);
  }
};
